'use client';

import type { ReactNode } from 'react';

import { cn } from '../../../lib/utils/cn';
import { AiLoaderIcon } from './ai-loader-icon';

export interface AiLoaderFrameProps {
  /** Leading icon. Defaults to the animated AiLoaderIcon; pass a node for a static glyph. */
  icon?: ReactNode;
  /** Classes for the frame root; the icon sits out of flow, so these lay out the children. */
  className?: string;
  children: ReactNode;
}

/**
 * The loader shell: a leading icon in a fixed 36px slot, taken out of the text flow so the text
 * alone sets the height. A taller icon then overflows the frame (its outer pixels are mostly orbit
 * clearance) instead of inflating it.
 *
 * The slot is centred on the first text line rather than the block, so a second line appearing
 * below never nudges the icon. 0.7rem is half of `typo-base`'s 1.4rem line box;
 */
export const AiLoaderFrame = ({
  icon = <AiLoaderIcon size={36} />,
  className,
  children,
}: AiLoaderFrameProps) => (
  <div className={cn('relative pl-[46px]', className)}>
    <div className="absolute top-[0.7rem] left-0 flex h-9 w-9 -translate-y-1/2 items-center justify-center">
      {icon}
    </div>
    {children}
  </div>
);
